<template>
  <l-layout :layout="['xs12']" bottom-space>
    <v-card>
      <v-card-title style="height: 64px">
        <span class="title pl-2">{{role.name}}</span>
        <span class="grey--text px-2" v-if="editing">正在编辑</span>
        <!--<v-layout class="pl-4" wrap>-->
        <!--<v-flex xs6>-->
        <!--<span class="grey&#45;&#45;text caption mr-2">创建时间</span>-->
        <!--<span class="pr-4">{{$L.time.stringify(role.creationTime) || 'N/A'}}</span>-->
        <!--</v-flex>-->
        <!--<v-flex xs6>-->
        <!--<span class="grey&#45;&#45;text caption mr-2">上次更新</span>-->
        <!--<span class="pr-4">{{$L.time.stringify(role.lastUpdateTime) || 'N/A'}}</span>-->
        <!--</v-flex>-->
        <!--</v-layout>-->
        <v-spacer></v-spacer>
        <v-btn @click="goReadonly()" color="primary" flat v-if="editing">返回</v-btn>
      </v-card-title>
      <v-card-text>
        <v-container class="py-0" fluid grid-list-md>
          <v-form ref="role">
            <v-layout class="mb-4" wrap>
              <v-flex sm4 xs12>
                <v-text-field
                  label="角色名称"
                  prepend-icon="$vuetify.icons.role"
                  v-model="role.name"
                ></v-text-field>
              </v-flex>
              <v-flex sm8 xs12>
                <v-text-field
                  label="Shiro字段"
                  prepend-icon="$vuetify.icons.shiroStr"
                  v-model="role.shiroStr"
                ></v-text-field>
              </v-flex>
              <v-flex xs12>
                <v-textarea
                  :rows="1"
                  auto-grow
                  label="角色描述"
                  prepend-icon="$vuetify.icons.description"
                  v-model="role.description"
                ></v-textarea>
              </v-flex>
              <v-flex v-if="editing" xs12>
                <v-btn
                  :loading="submitLoading"
                  @click="setRole(role)"
                  class="mx-0"
                  color="primary"
                  flat
                >提交更改
                </v-btn>
              </v-flex>
            </v-layout>
          </v-form>
          <v-subheader>绑定权限</v-subheader>
          <v-layout class="mb-4" wrap>
            <v-flex xs12>
              <l-data-table
                :headers="permissionHeaders"
                :items="role.permissionList"
                auto-actions
                flat
                hide-headers
                hide-title
                no-data-text="没有绑定权限"
                ref="permissionList"
              >
                <template slot="row-action" slot-scope="{item}">
                  <td @click.stop class="px-0 mx-0 text-xs-right">
                    <v-btn @click="deletePermission(item)" icon>
                      <v-icon small>$vuetify.icons.delete</v-icon>
                    </v-btn>
                  </td>
                </template>
              </l-data-table>
            </v-flex>
            <v-flex xs12>
              <v-btn @click="openPermissionDialog" class="mx-0" color="primary" flat>添加权限</v-btn>
            </v-flex>
          </v-layout>
        </v-container>
        <v-expand-transition>
          <v-container class="pt-0" fluid grid-list-md v-if="role.showGU && editing">
            <v-subheader>绑定分组</v-subheader>
            <v-layout class="mb-4" wrap>
              <v-flex xs12>
                <l-data-table
                  :get-data-func="getBindGroups"
                  :headers="groupHeaders"
                  auto-actions
                  flat
                  hide-headers
                  hide-title
                  no-data-text="没有绑定分组"
                  ref="groupList"
                ></l-data-table>
              </v-flex>
              <v-flex xs12>
                <v-btn @click="openGroupDialog" class="mx-0" color="primary" flat>添加分组</v-btn>
              </v-flex>
            </v-layout>
            <v-subheader>绑定用户</v-subheader>
            <v-layout class="mb-4" wrap>
              <v-flex xs12>
                <l-data-table
                  :get-data-func="getBindUsers"
                  :headers="userHeaders"
                  auto-actions
                  flat
                  hide-headers
                  hide-title
                  no-data-text="没有绑定用户"
                  ref="userList"
                >
                  <template slot="row-action" slot-scope="{item}">
                    <td @click.stop class="px-0 mx-0 text-xs-right">
                      <v-btn @click="deleteUser(item)" icon>
                        <v-icon small>$vuetify.icons.delete</v-icon>
                      </v-btn>
                    </td>
                  </template>
                </l-data-table>
              </v-flex>
              <v-flex xs12>
                <v-btn @click="openUserDialog" class="mx-0" color="primary" flat>添加用户</v-btn>
              </v-flex>
            </v-layout>
          </v-container>
        </v-expand-transition>
        <v-layout v-if="editing">
          <v-flex class="text-xs-center">
            <v-btn @click="role.showGU = !role.showGU" color="primary" flat>{{role.showGU ? '收起':'管理'}}已绑定用户和分组</v-btn>
          </v-flex>
        </v-layout>
      </v-card-text>
    </v-card>
    <v-layout class="mt-2" v-if="newItem">
      <v-flex class="text-xs-right">
        <v-btn :loading="submitLoading" @click="newRole(role)" class="mx-0" color="primary">提交</v-btn>
      </v-flex>
    </v-layout>
    <l-dialog
      :auto-close="newItem"
      :loading="groupDialog.loading"
      @cancel="closeGroupDialog"
      @confirm="addGroups(groupDialog.groups)"
      hide-divider
      max-width="500px"
      title="添加用户组"
      v-model="groupDialog.activate"
    >
      <v-container>
        <l-autocomplete
          :get-data="searchGroups"
          item-text="name"
          label="添加用户组"
          multiple
          prepend-icon="$vuetify.icons.group"
          v-model="groupDialog.groups"
        ></l-autocomplete>
      </v-container>
    </l-dialog>
    <l-dialog
      :auto-close="newItem"
      :loading="permissionDialog.loading"
      @cancel="closePermissionDialog"
      @confirm="addPermissions(permissionDialog.permissions)"
      hide-divider
      max-width="500px"
      title="添加权限"
      v-model="permissionDialog.activate"
    >
      <v-container>
        <l-autocomplete
          :get-data="searchPermissions"
          item-text="name"
          label="添加权限"
          multiple
          prepend-icon="$vuetify.icons.permission"
          v-model="permissionDialog.permissions"
        ></l-autocomplete>
      </v-container>
    </l-dialog>
    <l-dialog
      :auto-close="newItem"
      :loading="userDialog.loading"
      @cancel="closeUserDialog"
      @confirm="addUsers(userDialog.users)"
      hide-divider
      max-width="500px"
      title="添加用户"
      v-model="userDialog.activate"
    >
      <v-container>
        <l-autocomplete
          :init-data="false"
          :get-data="searchUsers"
          item-text="name"
          label="添加用户"
          item-value="id"
          item-sub-text="loginId"
          multiple
          prepend-icon="$vuetify.icons.person"
          v-model="userDialog.users"
        ></l-autocomplete>
      </v-container>
    </l-dialog>
  </l-layout>
</template>

<script>
import {Role} from '../../../object'
import {time} from '../../../ladmin/utils'

export default {
  name: 'roleForm',
  props: {
    role: {
      type: Object,
      default: () => (new Role())
    }
  },
  data: () => ({
    submitLoading: false,
    // showGU: false,
    groupDialog: {
      activate: false,
      groups: [],
      loading: false,
    },
    permissionDialog: {
      activate: false,
      permissions: [],
      loading: false,
    },
    userDialog: {
      activate: false,
      users: [],
      loading: false
    },
    groupHeaders: [
      {text: '分组名称', value: 'name', align: 'left', placeholder: 'N/A'},
      {text: '分组描述', value: 'description', align: 'right', placeholder: 'N/A'},
      {text: '上次修改', value: 'lastEditor', align: 'right', placeholder: 'N/A'},
      {text: '创建时间', value: 'creationTime', align: 'right', placeholder: 'N/A', f: v => time.stringify(v)},
      {text: '', value: '', align: 'right', width: '80px', sortable: false}
    ],
    userHeaders: [
      {text: '用户姓名', value: 'name', align: 'left', placeholder: 'N/A'},
      {text: '用户账号', value: 'loginId', align: 'right', placeholder: 'N/A'},
      {text: '上次修改', value: 'lastEditor', align: 'right', placeholder: 'N/A'},
      {text: '创建时间', value: 'creationTime', align: 'right', placeholder: 'N/A', f: v => time.stringify(v)},
      {text: '', value: '', align: 'right', width: '80px', sortable: false}
    ],
    permissionHeaders: [
      {text: '权限名称', value: 'name', align: 'left', placeholder: 'N/A'},
      {text: '权限描述', value: 'description', align: 'right', placeholder: 'N/A'},
      {text: '上次修改', value: 'lastEditor', align: 'right', placeholder: 'N/A'},
      {text: '创建时间', value: 'creationTime', align: 'right', placeholder: 'N/A', f: v => time.stringify(v)},
      {text: '', value: '', align: 'right', width: '80px', sortable: false}
    ],
  }),
  computed: {
    newItem () {
      return this.$route.name === 'NewRole'
    },
    editing () {
      return this.$route.name === 'EditRole'
    }
  },
  methods: {
    async newRole (role) {
      this.submitLoading = true
      let newRole = await this.setRole(role)
      console.log('new role success', newRole, role)
      if (newRole) {
        if (role.permissionList.length) {
          try {
            let permissions = role.permissionList
            await this.$store.dispatch('userAdmin/roleBindPermission', {role: newRole, permissions})
          }
          catch (e) {
            this.$L.alert('error', e.message)
            this.$store.dispatch('L/routerInTab').then(() => {
              this.$router.replace({
                name: 'EditRole',
                params: {shiroStr: newRole.shiroStr},
                query: {id: newRole.id}
              })
            })
            return
          }
        }
        this.$L.tab.close(this.$L.tab.current, false)
        this.$router.push({
          name: 'RoleList',
          params: {refresh: true}
        })
      }
      this.submitLoading = false
    },
    async setRole (role) {
      try {
        this.submitLoading = true
        let res = await this.$store.dispatch('userAdmin/setRole', role)
        // this.$refs.cache.retry(true)
        this.$L.alert('success', '提交成功')
        return res
      }
      catch (e) {
        this.$L.alert('error', {message: e.message})
      }
      finally {
        this.submitLoading = false
      }
    },
    getBindGroups (params) {
      return this.$store.dispatch('userAdmin/getGroupsByRole', {params, role: this.role})
    },
    getBindUsers (params) {
      return this.$store.dispatch('userAdmin/getUsersByRole', {params, role: this.role})
    },
    openGroupDialog () {
      this.groupDialog = {
        activate: true,
        groups: [],
        loading: false,
      }
    },
    closeGroupDialog () {
      this.groupDialog = {
        activate: false,
        groups: [],
        loading: false,
      }
    },
    async addGroups (items) {
      console.log('addGroups', items)
      if (items instanceof Array && items.length) {
        try {
          this.groupDialog.loading = true
          await this.$store.dispatch('userAdmin/roleBindGroups', {role: this.role, groups: items})
          this.$refs.groupList.refresh()
        }
        catch (e) {
          this.$L.alert('error', {message: 'e'})
        }
        finally {
          this.closeGroupDialog()
        }
      }
      // this.$emit('refresh')
      // this.closeGroupDialog()
    },
    async searchGroups (val) {
      try {
        let {items} = await this.$store.dispatch('userAdmin/getGroups', {
          pagination: {page: 1, rowsPerPage: 100},
          search: {key: 'name', value: val},
        })
        return items
      }
      catch (e) {
        this.$L.alert('error', {message: e.message})
        return []
      }
    },
    openUserDialog () {
      this.userDialog = {
        activate: true,
        users: [],
        loading: false,
      }
    },
    closeUserDialog () {
      this.userDialog = {
        activate: false,
        users: [],
        loading: false,
      }
    },
    async addUsers (users) {
      this.userDialog.loading = true
      try {
        await this.$store.dispatch('userAdmin/roleBindUsers', {role: this.role, users})
        // this.$emit('refresh')
        this.$refs.userList.refresh()
        this.closeUserDialog()
      }
      catch (e) {
        this.$L.alert('error', {message: e.message})
      }
      finally {
        this.userDialog.loading = false
      }
    },
    async deleteUser (user) {
      let {res, close} = await this.$L.confirm({title: '确认删除', text: `确认删除用户${user.name}？`})
      try {
        if (res) {
          await this.$store.dispatch('userAdmin/roleUnbindUser', {role: this.role, user})
          this.$L.alert('success', '删除成功')
          this.$refs.userList.refresh()
        }
      }
      catch (e) {
        this.$L.alert('error', {message: e.message})
      }
      finally {
        close()
      }
    },
    async searchUsers (val) {
      try {
        let {items} = await this.$store.dispatch('userAdmin/getUsers', {
          pagination: {page: 1, rowsPerPage: 100},
          search: {key: 'name', value: val},
        })
        return items
      }
      catch (e) {
        this.$L.alert('error', {message: e.message})
        return []
      }
    },
    openPermissionDialog () {
      this.permissionDialog = {
        activate: true,
        permissions: [],
        loading: false,
      }
    },
    closePermissionDialog () {
      this.permissionDialog = {
        activate: false,
        permissions: [],
        loading: false,
      }
    },
    async addPermissions (permissions) {
      if (this.newItem) {
        this.role.addPermission(...permissions)
      }
      else {
        this.permissionDialog.loading = true
        try {
          await this.$store.dispatch('userAdmin/roleBindPermission', {role: this.role, permissions})
          this.$emit('refresh')
          this.closePermissionDialog()
        }
        catch (e) {
          this.$L.alert('error', {message: e.message})
        }
        finally {
          this.permissionDialog.loading = false
        }
      }
    },
    async deletePermission (permission) {
      if (this.newItem) {
        this.role.deletePermission(permission)
      }
      else {
        let {res, close} = await this.$L.confirm({title: '确认删除', text: `确认删除权限${permission.name}？`})
        try {
          if (res) {
            await this.$store.dispatch('userAdmin/roleUnbindPermission', {role: this.role, permission})
            this.$L.alert('success', '删除成功')
            this.$emit('refresh')
          }
        }
        catch (e) {
          this.$L.alert('error', {message: e.message})
        }
        finally {
          close()
        }
      }
    },
    async searchPermissions (val) {
      try {
        let {items} = await this.$store.dispatch('userAdmin/getPermissions', {
          pagination: {page: 1, rowsPerPage: 10},
          search: {key: 'name', value: val},
        })
        return items
      }
      catch (e) {
        this.$L.alert('error', {message: e.message})
        return []
      }
    },
    goReadonly () {
      this.$store.dispatch('L/routerInTab').then(() => {
        this.$router.replace({
          name: 'RoleDetails',
          params: this.$route.params,
          query: this.$route.query
        })
      })
    }
  },
}
</script>

<style scoped>

</style>
